import React, { Component, Suspense } from "react";
import get from "lodash/get";
import { MEMBER_UPDATED } from "@quintype/components";
import { connect } from "react-redux";

const mapStateToProps = state => ({
  member: get(state, ["member"], null),
  isLoginOpen: get(state, ["isLoginOpen"], false),
  config: state.qt.config
});

const mapDispatchToProps = dispatch => ({
  openLoginTemplate: () => dispatch({ type: "OPEN_LOGIN_TEMPLATE" }),
  closeLoginTemplate: () => dispatch({ type: "CLOSE_LOGIN_TEMPLATE" }),
  updateMember: member => dispatch({ type: MEMBER_UPDATED, member })
});

export class DynamicImportSSO extends Component {
  constructor(props) {
    super(props);
    this.SSOWrapperBase = null;
    this.state = {
      isSSOLoaded: false
    };
  }

  componentDidUpdate(prevProp) {
    const prevIsLoginOpen = get(prevProp, ["isLoginOpen"], false);
    const currentIsLoginOpen = get(this.props, ["isLoginOpen"], false);

    if (prevIsLoginOpen !== currentIsLoginOpen) {
      setTimeout(() => this.dynamicImport(), 3000);
    }
  }

  dynamicImport() {
    this.SSOWrapperBase = React.lazy(() => import(/* webpackChunkName: "SSOWrapperBase" */ "./sso-wrapper"));
    this.setState({ isSSOLoaded: true });
  }

  render() {
    if (!this.state.isSSOLoaded) return null;

    return (
      <div>
        <Suspense fallback={<div>Loading...</div>}>
          <this.SSOWrapperBase {...this.props} />
        </Suspense>
      </div>
    );
  }
}

export const SSOWrapper = connect(
  mapStateToProps,
  mapDispatchToProps
)(DynamicImportSSO);
